/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AdmissionInitialAssessmentApi } from '../api/admissionInitialAssessment.api';
import { switchMap, map } from 'rxjs/operators';
import { AdmissionInitialAssessmentData,AdmissionInitialAssessment,AdmissionAdministrativeMaster } from '../../../interfaces/Ip/admissionInitialAssessment';

@Injectable()
export class AdmissionInitialAssessmentService extends AdmissionInitialAssessmentData {

  constructor(private api: AdmissionInitialAssessmentApi) {
    super();
  }


  list(url: string): Observable<AdmissionInitialAssessment[]> {
    return this.api.list(url);
  }

  create(url: string, data:AdmissionInitialAssessment): Observable<AdmissionInitialAssessment> {
    return this.api.add(url,data);
  }

  update(url: string, data:AdmissionInitialAssessment): Observable<AdmissionInitialAssessment> {
    return this.api.update(url,data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

  //Admission Admin


  listAdm(url: string): Observable<AdmissionAdministrativeMaster[]> {
    return this.api.listAdm(url);
  }

  createAdm(url: string, data:AdmissionAdministrativeMaster): Observable<AdmissionAdministrativeMaster> {
    return this.api.addAdm(url,data);
  }

  updateAdm(url: string, data:AdmissionAdministrativeMaster): Observable<AdmissionAdministrativeMaster> {
    return this.api.updateAdm(url,data);
  }

  deleteAdm(url: string): Observable<boolean> {
    return this.api.deleteAdm(url);
  }
}
